import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(private http: HttpClient) { }
  
  public getOrders(page: number, type: string = 'products'): Observable<any> {
    return this.http.get(`${BASEURL}/admin/orders?page=${page}&order_type=${type}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }
  public getFilteredOrders(page: number, type: string = 'products',status: string, per_page: number): Observable<any>{
    return this.http.get(`${BASEURL}/admin/orders?page=${page}&order_type=${type}&status=${status}&per_page=${per_page}`,{
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });    
  }
  public getPaidOrders(): Observable<any>{
    return this.http.get(`${BASEURL}/admin/orders?page=1&order_type=products&filter=paid`,{
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
  }
  public getPaymentsPending(): Observable<any> {
    return this.http.get(`${BASEURL}/payments_pending.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }

  public getOrder(orderId: number): Observable<any> {
    return this.http.get(`${BASEURL}/admin/orders/${orderId}.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }

  public destroyOrderInternProtocol(url: string): Observable<any> {
    return this.http.delete(url, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }

  public getOrdersByUser(userId: string): Observable<any> {
    return this.http.get(`${BASEURL}/admin/clients/${userId}/orders.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      responseType:'json'
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }

  public getOrderPaymentIntents(orderSlug:string): Observable<any>{
    return this.http.get(`${BASEURL}/v2/orders/${orderSlug}/payment_intents.json`,{
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public addInternProtocol(orderId: number, internProtocolId: number): Observable<any> {
    return this.http.put<any>(`${BASEURL}/admin/orders/${orderId}/add_intern_protocol.json`, { order: { intern_protocol_id: internProtocolId } }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      responseType: 'json'
    }).pipe(
      tap((response: any) => { }),
    );
  }

  public addCustomProtocol(orderId: number,protocolData:any):Observable<any>{
    return this.http.put(`${BASEURL}/admin/orders/${orderId}/add_item`,{item:protocolData},{
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      responseType: 'json'
    })
  }

  public createOrder(clientId:number, currency:string): Observable<any> {
    return this.http.post<any>(`${BASEURL}/admin/clients/${clientId}/orders.json`, {
      currency: currency
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      responseType: 'json'
    }).pipe(
      tap((response: any) => { }),
    );
  }

  public sendPayment(orderId:number, currency: string): Observable<any> {
    return this.http.put<any>(`${BASEURL}/admin/orders/${orderId}/send_payment.json`, {
      currency
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      responseType: 'json'
    }).pipe(
      tap((response: any) => { }),
    );
  }

  public addAddress(id: number, form: any): Observable<any> {
    return this.http.post<any>(`${BASEURL}/admin/orders/${id}/address.json`, {address: form}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      responseType: 'json'
    }).pipe(
      tap((response: any) => { }),
    );
  }

  public putAddress(addressID:number,addressData:any): Observable<any>{
    return this.http.put(`${BASEURL}/addresses/${addressID}`,{address:addressData},{
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      responseType: 'json'
    });
  }

  public cancelOrder(id:number): Observable<any>{
    return this.http.put<any>(`${BASEURL}/admin/orders/${id}/cancel`,{},{
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public destroyOrder(id:number): Observable<any>{
    return this.http.delete(`${BASEURL}/admin/orders/${id}`,{
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public toggleDonationAllowed(id: number): Observable<any> {
    return this.http.put(`${BASEURL}/admin/orders/${id}/toggle/donation_allowed`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public toggleShippingAddress(id: number): Observable<any> {
    return this.http.put(`${BASEURL}/admin/orders/${id}/toggle/shipping_address`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public toggleAutoConvertToMXN(id: number): Observable<any> {
    return this.http.put(`${BASEURL}/admin/orders/${id}/toggle/auto_convert_to_mxn`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public notifyOfflinePayment(id:number):Observable<any>{
    return this.http.put(`${BASEURL}/admin/orders/${id}/paid_offline`,{},{
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public addNoteToOrder(id: number, form: any): Observable<any> {
    return this.http.put(`${BASEURL}/admin/orders/${id}/note`, { orders: form }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }
}
